export const GET_PROFILE = 'PROFILE/GET_PROFILE';
export const UPDATE_PROFILE = 'PROFILE/UPDATE_PROFILE';

export const GET_BUSINESS = 'BUSINESS/get_business';
export const UPDATE_BUSINESS = 'BUSINESS/update_business';

export const GENERATE_2FA = 'PROFILE/enable_2fa';
export const ENABLE_2FA = 'PROFILE/enable_2fa';
export const DISABLE_2FA = 'PROFILE/disable_2fa';
export const CHANGE_PASSWORD = 'PROFILE/change_password';
export const UPDATE_OTP_SOURCE = 'PROFILE/update_otp_source';
